import { useAuthState } from 'state/useAuthState';

export const useProgressionModelsEnabled = (): boolean => {
  const { showMembershipProFeatures } = useAuthState();
  return showMembershipProFeatures;
};
